import React from 'react';
import { DatePicker, Select, Card } from 'antd';
import {
    UserOutlined,
    WarningOutlined,
    RiseOutlined,
    UserDeleteOutlined,
    FallOutlined,
    CaretUpOutlined,
    CaretDownOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';

// Define the shape of our metric data
interface MetricData {
    title: string;
    value: string | number;
    trend: string;
    isUp: boolean;
    icon: React.ReactNode;
    iconBg: string;
}

const DashboardMetrics: React.FC = () => {
    const metrics: MetricData[] = [
        {
            title: 'Total Employees',
            value: '132',
            trend: '+4.6%',
            isUp: true,
            icon: <UserOutlined className="text-[#722ed1] text-xl" />,
            iconBg: 'bg-[#f9f0ff]',
        },
        {
            title: 'Active PIP',
            value: '5',
            trend: '-2%',
            isUp: false,
            icon: <WarningOutlined className="text-[#fa8c16] text-xl" />,
            iconBg: 'bg-[#fff7e6]',
        },
        {
            title: 'Performance Growth',
            value: '82%',
            trend: '+5.6%',
            isUp: true,
            icon: <RiseOutlined className="text-[#52c41a] text-xl" />,
            iconBg: 'bg-[#f6ffed]',
        },
        {
            title: 'Terminations',
            value: '3',
            trend: '-2%',
            isUp: false,
            icon: <UserDeleteOutlined className="text-[#13c2c2] text-xl" />,
            iconBg: 'bg-[#e6fffb]',
        },
        {
            title: 'Low Performers',
            value: '10',
            trend: '-2%',
            isUp: false,
            icon: <FallOutlined className="text-[#f5222d] text-xl" />,
            iconBg: 'bg-[#fff1f0]',
        },
    ];

    return (
        <div className=" ">
            {/* Top Controls */}
            <div className="flex justify-end items-center gap-3 mb-6">
                <div className=""><Select
                    defaultValue="Department"
                    style={{ width: 140 }}
                    options={[{ value: 'all', label: 'All Departments' }]}
                /></div>
                <div className="">  <DatePicker defaultValue={dayjs('2025-08-29')} format="DD-08-2025" /></div>
            </div>

            {/* Grid Layout */}
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                {metrics.map((m, idx) => (
                    <Card key={idx} bordered={false} className="rounded-xl shadow-sm hover:shadow-md transition-shadow">
                        <div className="flex items-start gap-4 h-full">
                            {/* Icon Container */}
                            <div className={`${m.iconBg} p-3 rounded-lg flex items-center justify-center shrink-0`}>
                                {m.icon}
                            </div>

                            {/* Text Content */}
                            <div className="flex flex-col justify-between h-24 w-full">
                                <div>
                                    <div className="text-2xl font-bold text-[#262626] leading-tight">
                                        {m.value}
                                    </div>
                                    <div className="text-sm text-[#8c8c8c] whitespace-nowrap">
                                        {m.title}
                                    </div>
                                </div>

                                {/* Trend Footer */}
                                <div className="flex justify-end items-center w-full">
                                    <div className={`flex items-center text-xs font-bold ${m.isUp ? 'text-green-500' : 'text-red-500'}`}>
                                        {m.trend}
                                        {m.isUp ? <CaretUpOutlined className="ml-1" /> : <CaretDownOutlined className="ml-1" />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default DashboardMetrics;